"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _default = exports.default = {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    unreadCount: {
      type: Number,
      default: 0
    }
  },
  // render(h, context) {
  //   const { icon, title } = context.props
  //   const vnodes = []
  //   if (icon) {
  //     vnodes.push(<svg-icon icon-class={icon} style="font-size:16px"/>)
  //   }
  //   if (title) {
  //     vnodes.push(<span slot='title' style="font-size:14px">{(title)}</span>)
  //   }
  //   return vnodes
  // }
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title,
      unreadCount = _context$props.unreadCount;
    var vnodes = [];
    if (icon) {
      if (unreadCount > 0) {
        vnodes.push( // <span>
        h("svg-icon", {
          "attrs": {
            "icon-class": icon
          },
          "style": "font-size:14px"
        }));
        vnodes.push(h("span", {
          "class": 'unread-badge',
          "style": "visibility:visible;position: absolute;right:0;backgroundColor: #ff4d4f;color: white;borderRadius: 10px;minWidth: 18px;height: 18px;display: inline-flex;alignItems: center;justifyContent: center;fontSize: 10px;fontWeight: bold;padding: 0 4px;boxShadow: 0 0 0 1px #fff;marginLeft: 8px"
        }, [unreadCount > 99 ? '99' : unreadCount]));
      } else {
        vnodes.push(h("svg-icon", {
          "attrs": {
            "icon-class": icon
          },
          "style": "font-size:16px"
        }));
      }
    }
    if (title) {
      //   if(title=='公司管理'){
      //       console.log(112)
      //   }else{
      if (unreadCount > 0) {
        vnodes.push(h("span", {
          "slot": 'title',
          "style": "font-size:14px"
        }, [title, h("span", {
          "class": 'unread-badge',
          "style": "position: absolute;right:0;backgroundColor: #ff4d4f;color: white;borderRadius: 10px;minWidth: 18px;height: 18px;display: inline-flex;alignItems: center;justifyContent: center;fontSize: 10px;fontWeight: bold;padding: 0 4px;boxShadow: 0 0 0 1px #fff;marginLeft: 8px"
        }, [unreadCount > 99 ? '99' : unreadCount])]));
      } else {
        vnodes.push(h("span", {
          "slot": 'title',
          "style": "font-size:14px"
        }, [title]));
      }
      //   }
    }
    return vnodes;
  }
};